import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { useLoadStatisticWidget } from '../../hooks';

import { WIDGET_ID } from './constants';
import { Skeleton } from './Skeleton';

const StatisticsWidget = (): JSX.Element => {
  const { isLoaded } = useLoadStatisticWidget();
  const { t } = useTranslation();

  return (
    <Container>
      <HeadingContainer>
        <HeadingTitle>{t('home_statistics_widget.title')}</HeadingTitle>
        <HeadingDescription>
          {t('home_statistics_widget.description')}
        </HeadingDescription>
      </HeadingContainer>
      <WidgetContainer>
        {!isLoaded && <Skeleton />}
        <WidgetElement id={WIDGET_ID} $isHidden={!isLoaded} />
      </WidgetContainer>
    </Container>
  );
};

const Container = styled.div`
  margin: 40px 0 20px;
`;

const HeadingContainer = styled.div`
  color: #737373;

  text-align: center;
`;

const HeadingTitle = styled.div`
  font-size: 24px;
  line-height: 33px;
  color: black;
`;

const HeadingDescription = styled.div`
  font-size: 14px;
`;

const WidgetContainer = styled.div`
  padding: 20px;
  min-height: 439px;
  position: relative;
`;

const WidgetElement = styled.div<{ $isHidden: boolean }>`
  ${({ $isHidden }) => $isHidden && 'display: none;'}

  *,
  *::before,
  *::after {
    box-sizing: content-box;
  }
`;

export default StatisticsWidget;
